import { qa } from "../plugins/helpers";

export function services() {
    qa("#topic-modal p").forEach(para => {
        if (para.innerHTML.indexOf("integratedly") > -1)
            para.innerHTML = para.innerHTML.replace("integratedly", "holistically");
    });
}